"use strict";
/**
 * Comparison Engine Types
 *
 * Shared type definitions for the policy-to-product comparison engine.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCUMULATION_CARRIER_CONFIG = exports.INCOME_CARRIER_CONFIG = exports.EXCLUDED_CARRIERS = exports.AM_BEST_MINIMUM_RATING = exports.AM_BEST_SCORE = exports.PRODUCT_TYPE_COMPATIBILITY = void 0;
exports.getCarrierConfig = getCarrierConfig;
exports.PRODUCT_TYPE_COMPATIBILITY = {
    FIA_ACCUMULATION: ['FIA'],
    FIA_INCOME: ['FIA'],
    MYGA: ['MYGA', 'Fixed', 'FIA'],
    TRADITIONAL_FIXED: ['MYGA', 'Fixed', 'FIA'],
    VA: ['FIA'],
    RILA: ['RILA', 'FIA'],
};
exports.AM_BEST_SCORE = {
    'A++': 100,
    'A+': 90,
    A: 80,
    'A-': 70,
    'B++': 60,
};
/** Minimum acceptable AM Best rating — products below B++ are excluded */
exports.AM_BEST_MINIMUM_RATING = 'B++';
/** Carriers excluded from all product recommendations (legacy — use category-specific lists) */
exports.EXCLUDED_CARRIERS = ['NATIONAL LIFE'];
exports.INCOME_CARRIER_CONFIG = {
    excludedCarriers: [
        'NATIONAL WESTERN LIFE',
        'PRUDENTIAL',
        'SYMETRA',
        'NASSAU',
        'PROTECTIVE LIFE',
        'PROTECTIVE',
        'NATIONAL LIFE GROUP',
        'NATIONAL LIFE',
        'AMERICAN NATIONAL',
        'OXFORD',
    ],
    excludedProducts: ['ASSURED EDGE INCOME ACHIEVER'],
    topCarriers: [
        'EQUITRUST',
        'AMERICAN EQUITY',
        'NORTH AMERICAN',
        'ATHENE',
        'MASS MUTUAL',
        'MASSMUTUAL',
        'TALCOTT',
        'FG',
        'FIDELITY & GUARANTY',
        'GLOBAL',
        'GLOBAL ATLANTIC',
        'DELAWARE LIFE',
        'NATIONWIDE',
        'APSIDA',
        'ALLIANZ',
        'GILICO',
        'COREBRIDGE',
        'LEGACY AMERITAS',
        'AMERITAS',
    ],
    boostedCarriers: [
        'EQUITRUST',
        'AMERICAN EQUITY',
        'NORTH AMERICAN',
        'TALCOTT',
        'FG',
        'FIDELITY & GUARANTY',
        'COREBRIDGE',
    ],
    boostAmount: 5,
};
exports.ACCUMULATION_CARRIER_CONFIG = {
    excludedCarriers: [
        'NASSAU',
        'NATIONAL WESTERN LIFE',
        'SYMETRA',
        'PRUDENTIAL',
        'FG',
        'FIDELITY & GUARANTY',
        'PROTECTIVE LIFE',
        'PROTECTIVE',
        'NATIONAL LIFE GROUP',
        'NATIONAL LIFE',
        'TALCOTT',
        'NATIONWIDE',
        'COREBRIDGE',
        'GLOBAL',
        'GLOBAL ATLANTIC',
        'OXFORD',
        'LEGACY AMERITAS',
        'AMERITAS',
    ],
    excludedProducts: [],
    topCarriers: [
        'STANDARD',
        'STANDARD INSURANCE',
        'IBEXIS',
        'OCEANVIEW',
        'MASS MUTUAL',
        'MASSMUTUAL',
        'LINCOLN',
        'LINCOLN FINANCIAL',
        'EQUITRUST',
        'ALLIANZ',
        'GILICO',
        'ATHENE',
        'AMERICAN EQUITY',
        'GLOBAL',
        'GLOBAL ATLANTIC',
        'AXONIC',
        'NORTH AMERICAN',
        'DELAWARE LIFE',
    ],
    boostedCarriers: [
        'STANDARD',
        'STANDARD INSURANCE',
        'IBEXIS',
        'OCEANVIEW',
        'MASS MUTUAL',
        'MASSMUTUAL',
        'LINCOLN',
        'LINCOLN FINANCIAL',
    ],
    boostAmount: 5,
};
/** Get carrier config for a given product category */
function getCarrierConfig(category) {
    if (category === 'FIA_INCOME')
        return exports.INCOME_CARRIER_CONFIG;
    return exports.ACCUMULATION_CARRIER_CONFIG;
}
//# sourceMappingURL=comparison.js.map